interface SubscriberData {
  email: string;
}

// Local storage functions - no backend dependency
const STORAGE_KEY = 'ss_plastic_subscribers';

export async function subscribe(data: SubscriberData): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, 300));
  
  const stored = localStorage.getItem(STORAGE_KEY);
  const subscribers: string[] = stored ? JSON.parse(stored) : [];
  
  if (!subscribers.includes(data.email)) {
    subscribers.push(data.email);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(subscribers));
  }
}

export async function unsubscribe(id: string): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, 200));
  
  const stored = localStorage.getItem(STORAGE_KEY);
  const subscribers: string[] = stored ? JSON.parse(stored) : [];
  
  const index = subscribers.indexOf(id);
  if (index > -1) {
    subscribers.splice(index, 1);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(subscribers));
  }
}